import { useCallback, useEffect, useState, useRef } from "react";
import { initialPaging } from "../Constants/paging";
import { CallApiGetVoucherHistories } from "../Api/Enforcement";

export const useAdminVoucherHistoryPage = () => {
  const [voucherHistories, setVoucherHistories] = useState([]);
  const [paging, setPaging] = useState(initialPaging);
  const [search, setSearch] = useState("");

  const initialState = useRef(true);

  const getVoucherHistories = useCallback(
    (pageNumber) => {
      const data = {
        searchText: search,
        page: pageNumber !== undefined ? pageNumber : paging.pageIndex,
        isClosed: false,
      };

      CallApiGetVoucherHistories(data, (res) => {
        if (res.Status === "success") {
          var data = res.Response.data;
          setVoucherHistories(data.Items);
          setPaging((prev) => ({
            ...prev,
            next: data.Next,
            previous: data.Previous,
            totalPages: data.TotalPagesCount,
            pageIndex: data.PageIndex,
          }));
        }
      });
    },
    [setVoucherHistories, setPaging, search, paging]
  );

  useEffect(() => {
    if (initialState.current) {
      getVoucherHistories();
      initialState.current = false;
    }
  }, [getVoucherHistories]);

  return {
    search,
    voucherHistories,
    paging,
    setSearch,
    getVoucherHistories,
  };
};
